
const CTASection = () => {
  return (
    <section className="relative py-40 overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/a44de1ef9e6abc2a28b96f7612ff1bd9.jpg"
          alt="Breakthrough Background"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-black/70"></div>
      </div>

      {/* X Pattern Overlay */}
      <div className="absolute inset-0 opacity-5">
        <svg className="w-full h-full" xmlns="http://www.w3.org/2000/svg">
          <defs>
            <pattern id="xPatternCta" x="0" y="0" width="100" height="100" patternUnits="userSpaceOnUse">
              <line x1="0" y1="0" x2="100" y2="100" stroke="#10B981" strokeWidth="1" />
              <line x1="100" y1="0" x2="0" y2="100" stroke="#10B981" strokeWidth="1" />
            </pattern>
          </defs>
          <rect width="100%" height="100%" fill="url(#xPatternCta)" />
        </svg>
      </div>

      {/* Glowing X */}
      <div className="absolute inset-0 flex items-center justify-center">
        <div className="text-emerald-500/20 text-[400px] font-bold blur-2xl">✕</div>
      </div>

      <div className="relative z-10 max-w-4xl mx-auto px-6 lg:px-8 text-center">
        <h2 className="text-5xl lg:text-7xl font-extrabold text-white mb-12 leading-tight">
          Turn the Bottleneck<br />Into the <span className="text-transparent bg-clip-text bg-gradient-to-r from-emerald-400 to-teal-400">Breakthrough.</span>
        </h2>

        <a
          href="/contact"
          className="inline-flex items-center gap-3 px-14 py-5 bg-gradient-to-r from-emerald-500 to-teal-500 text-white font-bold rounded-lg hover:from-emerald-400 hover:to-teal-400 transition-all duration-300 whitespace-nowrap cursor-pointer shadow-2xl shadow-emerald-500/40 hover:shadow-emerald-500/60 hover:scale-105 text-lg"
        >
          Book a Strategy Session
          <i className="ri-arrow-right-line text-xl"></i>
        </a>
      </div>
    </section>
  );
};

export default CTASection;
